import { Box, Image, Text, Tag, VStack, HStack } from "@chakra-ui/react";
import { PK12 } from "../../constants";

export const ProductInfo = ({product, mt}) => {
  return (
    <Box 
      display="flex" 
      overflow="hidden" 
      bg="white" 
      p={6} 
      rounded="lg" 
      shadow="md"
      mt={mt}
    >
      {/* Image Placeholder */}
      <Box 
        w="80px" 
        h="80px" 
        display="flex" 
        alignItems="center" 
        justifyContent="center" 
        borderRadius="md"
        flexShrink={0}
      >
        <Image src={product?.productCoverPath} />
      </Box>

      {/* Content */}
      <VStack align="start" spacing={2} ml={4} flex="1">
        <Text fontWeight="bold" fontSize="lg" isTruncated>
          {product?.productName}
        </Text>
        <Text fontSize="sm" color="gray.600">
          {product?.productDescription}
        </Text>
        <HStack spacing={2}>
          <Tag size="sm" colorScheme="gray">{product?.productCategory?.name}</Tag>
          {product?.productCategory?.parentCategory?.id ? <Tag size="sm" colorScheme="gray">{product.productCategory.parentCategory.name}</Tag> : <></>}
          {
            product?.productCategory?.name === PK12 ?
              <>
                <Tag size="sm" colorScheme="gray">{product?.productSubjects[0]?.name}</Tag>
                {
                  product.productGrades.map(grade => <Tag size="sm" colorScheme="gray" key={grade.id}>Grade: {grade.name}</Tag>)
                }
              </> : <></>
          }
        </HStack>
      </VStack>
    </Box>
  );
};

